export enum CompanyDocumentType {
  AUTHORITY_CONFIRMATION = 'AUTHORITY_CONFIRMATION',
  PASSPORT = 'PASSPORT',
  TIN = 'TIN',
  ACCESSION_AGREEMENT = 'ACCESSION_AGREEMENT',
  SIGNED_ACCESSION_AGREEMENT = 'SIGNED_ACCESSION_AGREEMENT',
  ONBOARDING_DOCUMENT = 'ONBOARDING_DOCUMENT',
  SIGNED_ONBOARDING_DOCUMENT = 'SIGNED_ONBOARDING_DOCUMENT',
  PERSONAL_DATA_AGREEMENT = 'PERSONAL_DATA_AGREEMENT',
}

export const mapDocumentTypeToLabel: {
  [key in keyof typeof CompanyDocumentType]: string;
} = {
  [CompanyDocumentType.AUTHORITY_CONFIRMATION]:
    'Документ подтверждающий полномочия',
  [CompanyDocumentType.PASSPORT]: 'Документ удостоверяющий личность',
  [CompanyDocumentType.TIN]: 'Свидетельство ИНН компании',
  [CompanyDocumentType.PERSONAL_DATA_AGREEMENT]:
    'Согласие на обработку персональных данных',
  [CompanyDocumentType.ONBOARDING_DOCUMENT]: 'Договор о присоединении',
  [CompanyDocumentType.SIGNED_ONBOARDING_DOCUMENT]:
    'Подписанный договор о присоединении',
  [CompanyDocumentType.ACCESSION_AGREEMENT]: 'Соглашение о присоединении',
  [CompanyDocumentType.SIGNED_ACCESSION_AGREEMENT]:
    'Подписанное соглашение о присоединении',
};

export interface ICompanyDocument {
  id: number;
  organizationId: number;
  type: CompanyDocumentType;
  originalFilename: string;
  pageCount: number;
  weight: number;
  original: boolean;
  signed: boolean;
  createdAt: string;
  lastModifiedAt: string;
}

export interface ICompanyVerificationInfo {
  organizationId: number;
  verified: boolean;
  createdDate: string;
  organizationName: string;
  organizationFullName: string;
  regNumber: string;
  tin: string;
  kpp: string;
  isPersonal: boolean;
  documents: ICompanyDocument[];
  initiatorFullName: string;
  initiatorRank: string;
  initiatorEmail: string;
  initiatorPhoneNumber: string;
}
